import { newFolder, cutFolder, mutate } from "./folder_state";

export default class {
  constructor(inputTarget) {
    this.inputTarget = inputTarget;
  }

  async folders() {
    return this.state;
  }

  async create(parentId, name) {
    const [state, folder] = newFolder(this.state, name);
    this.state = mutate(state, (node) =>
      node.id == parentId
        ? { ...node, children: node.children.concat(folder) }
        : node,
    );
    return folder;
  }

  async rename(folderId, name) {
    this.state = mutate(this.state, (node) =>
      node.id == folderId ? { ...node, name } : node,
    );
  }

  async move(folderId, parentId) {
    const [state, folder] = cutFolder(this.state, folderId);
    this.state = mutate(state, (node) =>
      node.id == parentId
        ? { ...node, children: node.children.concat(folder) }
        : node,
    );
  }

  async delete(folderId) {
    this.state = mutate(this.state, (node) =>
      node.id == folderId ? null : node,
    );
  }

  async addDocumentToFolder() {
    // no-op for input store
  }

  get state() {
    return JSON.parse(this.inputTarget.value);
  }

  set state(state) {
    this.inputTarget.value = JSON.stringify(state);
  }
}
